import request from '@/utils/request'
const BASE_URL = '/pdd/goods'

export default {
  /** 商品同步 */
  sync(data) {
    return request({
      url: BASE_URL + '/sync',
      method: 'post',
      data
    })
  },
  /** 同步状态查询 */
  syncStatus() {
    return request({
      url: BASE_URL + '/syncstatus',
      method: 'get',
    })
  },
  /** 更新商品数据 */
  update() {
    return request({
      url: BASE_URL + '/update',
      method: 'post',
    })
  },
  /** 更新状态查询 */
  updateStatus() {
    return request({
      url: BASE_URL + '/updatestatus',
      method: 'get',
    })
  },
  /** 商品类目 */
  cats(catId) {
    return request({
      url: BASE_URL + '/cats/' + catId,
      method: 'get',
    })
  },
  /** 商品列表 */
  getGoods(params, mallId = null) {
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL,
      method: 'get',
      params,
      headers: headers
    })
  },
  /** 商品详情 */
  detail(goodsId, mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/detail/' + goodsId,
      method: 'get',
      headers: headers
    })
  },
  /** 更新库存 */
  stock(data, mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/stock',
      method: 'put',
      data,
      headers: headers
    })
  },
  /** 商品上/下架 */
  salestatus(data, mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/salestatus',
      method: 'put',
      data,
      headers: headers
    })
  },
  /** 商品编辑 */
  put(data, mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL,
      method: 'put',
      data,
      headers: headers
    })
  },
  /** 商品删除 */
  delete(data, mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL,
      method: 'delete',
      data,
      headers: headers
    })
  },
}
